import { useState } from 'react';

import { Button, Icon } from '@liscio/ui';

import { RfiArchiveDialog } from '../../dialogs/RfiArchiveDialog';

export interface RfiArchiveButtonProps {
  requestUuid: string;
  disabled?: boolean;
}

export const RfiArchiveButton: React.FC<RfiArchiveButtonProps> = ({
  requestUuid,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        disabled={disabled}
        variant="outlined"
        startIcon={<Icon icon="archive" />}
        sx={{ color: 'grey.700', borderColor: 'grey.500' }}
      >
        Archive
      </Button>
      <RfiArchiveDialog
        open={open}
        onClose={() => setOpen(false)}
        requestUuid={requestUuid}
      />
    </>
  );
};

export default RfiArchiveButton;
